// import { Button } from "primereact/button";
import { useNavigate } from "react-router";
import { useRef } from "react";
import { ItemDetail } from "../../constants/interface";
import { useCart } from "../../custom-hook/CartContext";
import "./ProductItem.scss";

interface Props {
    productItem: ItemDetail;
    onAddToCart?: (productName: string) => void;
}

function ProductItem({ productItem, onAddToCart }: Props) {
    const navigate = useNavigate();
    const { addToCart } = useCart();
    const touchStartTime = useRef<number>(0);
    const touchStartPosition = useRef<{ x: number; y: number }>({ x: 0, y: 0 });
    
    const directProductDetail = (productItem: ItemDetail) => {
        navigate(`/${productItem.category_code}/${productItem.id}`)
    }

    // const handleAddToCart = (e: React.MouseEvent) => {
    //     e.stopPropagation(); // Prevent navigation to product detail
    //     addToCart({
    //         id: productItem.id,
    //         name: productItem.name || "",
    //         price: productItem.price,
    //         salePrice: productItem.salePrice,
    //         img: productItem.img || "",
    //         quantity: 1,
    //         category_code: productItem.category_code,
    //         category_detail_name: productItem.category_detail_name
    //     });
        
    //     // Call the callback to show toast from parent component
    //     if (onAddToCart) {
    //         onAddToCart(productItem.name || "");
    //     }
    // };

    const handleTouchStart = (e: React.TouchEvent) => {
        touchStartTime.current = Date.now();
        const touch = e.touches[0];
        touchStartPosition.current = { x: touch.clientX, y: touch.clientY };
    };

    const handleTouchEnd = (e: React.TouchEvent) => {
        const touchEndTime = Date.now();
        const touchDuration = touchEndTime - touchStartTime.current;
        
        // Only navigate if it's a quick tap (not a long press or swipe)
        if (touchDuration < 300) {
            const touch = e.changedTouches[0];
            const deltaX = Math.abs(touch.clientX - touchStartPosition.current.x);
            const deltaY = Math.abs(touch.clientY - touchStartPosition.current.y);
            
            // Only navigate if it's not a swipe (small movement)
            if (deltaX < 10 && deltaY < 10) {
                directProductDetail(productItem);
            }
        }
    };

    const handleClick = (e: React.MouseEvent) => {
        // For mouse clicks, always navigate
        directProductDetail(productItem);
    };

    return (
        <div
            className="product-item-card"
            onClick={handleClick}
            onTouchStart={handleTouchStart}
            onTouchEnd={handleTouchEnd}
        >
            {productItem.price !== productItem.salePrice && (
                <span className="product-item-sale-percent">
                    -{((1 - productItem.salePrice / productItem.price) * 100).toFixed(0)}%
                </span>
            )}
            <div className="product-item-card-img">
                <img src={productItem.img} alt={productItem.name} />
            </div>
            <p className="product-item-card-name">{productItem.name}</p>
            <div className="product-item-card-price">
                <span className="product-item-price-sale">
                    {productItem.salePrice.toLocaleString("vi-VN")}đ
                </span>
                {productItem.price !== productItem.salePrice && (
                    <span className="product-item-price-original">
                        {productItem.price.toLocaleString("vi-VN")}đ
                    </span>
                )}
            </div>
            {/* <div className="product-item-add-to-cart">
                <Button
                    icon="pi pi-shopping-bag"
                    size="small"
                    onClick={handleAddToCart}
                    className="product-item-cart-button"
                />
            </div> */}
        </div>
    );
}

export default ProductItem;
